<template>
    <div style="width: 100%;">
        <b-alert show v-if="client_audit && client_audit.sessions.length == 0">
            No sessions found
        </b-alert>

        <div class="" style="">
            <b-button v-show="selected_audit_session_data == null"  variant="primary" class="me-2 mb-2" @click="startSession(client_audit)"><strong>New Audit Session</strong></b-button>
            <h4  v-if="selected_audit_session_data">Audit Session: <strong>{{getDate(selected_audit_session_data.start_date)}}</strong></h4>
        </div>
        <SessionsTable
        v-if="audit_view_uid == null && client_audit.sessions.length > 0"
        :sessions="client_audit.sessions"
        @selectedRow="handleRowSelect" />

        <b-row v-if="audit_view_uid != null">
            <b-col cols="12">
                <b-card>
                    <form-plugin :uid="audit_view_uid"
                    :viewData="form_data"
                    :activeAudit="isAuditActive"
                    :viewFile="getFormFiles"
                    @savedEvent="handleSave"
                    @endAudit="endCurrentAuditSession"
                    local_data
                    version2
                    @uploaderData="handleUploadFile"
                    @downloadFile="handleEvidenceDownload"
                    @deleteFile="handleEvidenceDelete"
                    enableSaveButton enable_contents_table></form-plugin>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SessionsTable from './sessionsTable.vue'
import _ from 'lodash';
import Uploader from 'simple-uploader.js'
import { facilityAdminState, facilityAdminMethods } from '@/state/helpers'
import dateMixin from '@/mixins/dateMixin.js'
export default {
    components:{ SessionsTable },
    mixins: [dateMixin],
    data:() => ({
        form_data: [],
    }),
    computed:{
        ...facilityAdminState,
        isAuditActive() {
            let selectedId = this.selected_audit_session_id;
            let index = _.findIndex(this.client_audit.sessions, function(o) { return o.id == selectedId; });
            if (index > -1) {
                return Boolean(this.client_audit.sessions[index].active);
            }
            return false;
        },
        qms_audit(){
            let data = null;
            if(this.selected_audit_session_data != null){
                data = this.selected_audit_session_data.qms_audit;
            }
            return data;
        },
        audit_view_uid(){
            let view = null;
            if(this.qms_audit != null && this.qms_audit.views[0] != undefined){
                view = this.qms_audit.views[0].spreadify_uid;
            }
            return view;
        },
        getFormFiles(){
            let evidence = {};
            this.form_data.forEach( group => {
                group.evidence.forEach(( file )=>{
                    if(evidence[file.form_key] == undefined){
                        evidence[file.form_key] = [];
                    }
                    evidence[file.form_key].push(file);
                })
            })
            return evidence;
        }
    },
    methods:{
        ...facilityAdminMethods,
        testMe(){
            alert('Tested');
        },
        startSession(id){
            this.startNewAuditSession(id).then(()=>{
                this.getClientAudit(this.selected_audit);
            })
        },
        selectSession(item){
            //TODO - add unsaved changes check
            this.setSelectedSessionID(item.id)
            .then(()=>{
                this.loadFromData(item.id);
            })
        },
        loadFromData(session_id){
            this.getClientAuditSessionData(session_id)
            .then(()=>{
                console.log('DEBUGG', this.selected_audit_session_data)
                this.form_data = _.cloneDeep(this.selected_audit_session_data.form_data);
            })
        },
        showSessionDeletePrompt(session_id){
            this.$swal.fire({
                title: "Delete Audit Session?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes"
            }).then(result => {
                if (result.value) {
                    this.deleteAuditSession(session_id).then(()=>{
                        this.getClientAudit(this.selected_audit);
                    })
                }
            });
        },
        handleUploadFile(payload){
            this.processUpload(payload.file, payload.form_key)
        },
        handleEvidenceDownload(evidence_id){
            alert(evidence_id)
        },
        handleEvidenceDelete(evidence_id){
            this.deleteEvidenceFile(evidence_id)
            .then(()=>{
                this.loadFromData(this.selected_audit_session_id);
            })
        },
        processUpload(file, form_key){
            //* Uploader event method
            let storage = window.localStorage;
            let AUTH_TOKEN = storage.getItem('x_token');
            let uploader = new Uploader({
                target: process.env.VUE_APP_API_BASEURL + 'api/facilityaudits/uploadevidence',
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                query:{
                    audit_session_id: this.selected_audit_session_id,
                    audit_data_id: 4,
                    spreadify_uid : this.audit_view_uid,
                    form_key: form_key,
                },
                testChunks: false,
                fileParameterName: 'evidence', //Set the upload post param which will contain the binary payload
                singleFile: Array.isArray(file),
            });
            //eslint-disable-next-line
            uploader.on('fileProgress', function (rootFile, file, chunk) {
                console.log(chunk)
                let xhr = chunk.xhr.response;
                let response = xhr.split(',');
                if(response.length == 2){
                    let done = response[0].split(':');
                    //console.log('event', done[1])
                    let payload = {
                        progress: done[1],
                        form_key: form_key
                    }
                    window.inst.$eventHub.$emit('uploaderProgress', payload);
                }
            });
            //eslint-disable-next-line
            uploader.on('fileComplete', function (rootFile, file, message,chunk) {
                let payload = {
                    progress: '100',
                    form_key: form_key
                }
                window.inst.$eventHub.$emit('uploaderProgress', payload);
                window.inst.loadFromData(window.inst.selected_audit_session_id);
            });
            //eslint-disable-next-line
            uploader.on('fileAdded', function (file, event) {
                //this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'File Uploaded', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
                
            });

            this.$nextTick(()=>{
                uploader.addFile(file);
                this.$nextTick(()=>{
                    uploader.upload();
                    console.log(uploader);
                })
            });
        },
        endCurrentAuditSession() {
            this.$swal.fire({
                title: "End Audit Session?",
                text: "The session will no longer be editable!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes"
            }).then(result => {
                if (result.value) {
                    this.endAuditSession(this.selected_audit_session_id).then(()=>{
                        this.getClientAudit(this.selected_audit);
                        this.$swal.fire("Ended", "Audit Session Ended!", "success");
                    });
                }
            });
        },
        handleSave(incomingData){
           //eslint-disable-next-line
            let el = this;
            let save_params = {
                audit_session_id: this.selected_audit_session_id,
                compliant: incomingData.compliance_data.compliant,
                compliance_percentage: incomingData.compliance_data.compliance_percentage,
                session_data: [],
            };
            let tempSessionData = [];
            Object.keys(incomingData.form_data).forEach( (Key) => {
                let params = {
                    spreadify_uid: this.audit_view_uid,
                    value: incomingData.form_data[Key],
                    form_key: Key,
                };
                tempSessionData.push(params);
            });

            let chunkedSave = _.chunk(tempSessionData, 30);
            let savedKeys = [];
            _.forEach(chunkedSave, function(value, key) {
                save_params.session_data = value;
                if(save_params.session_data.length > 0){
                    el.saveAuditSessionForm(save_params).then(()=>{
                        savedKeys.push(key);
                        if (savedKeys.length == chunkedSave.length) {
                            el.getClientAudit(el.selected_audit);
                            el.$swal.fire("Saved", "Audit Session Saved!", "success");
                        }
                    });
                }
            });

        },
        handleRowSelect(id){
            this.selectSession({id: id});
        }
    },
    mounted(){
        window.inst = this;
    },
    beforeDestroy(){
        window.inst = undefined;
    }
}
</script>

<style>
 .selected-item{
    font-weight: bold;
    text-decoration: underline black;
 }
</style>